export default function getWindowFromSeason(season) {
  let window = "BOY";
  if (season === "winter") window = "MOY";
  if (season === "spring") window = "EOY";
  return window;
}